import React, { Fragment, useState, useEffect } from "react";
import { Row, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import LicService from "../../../../../services/licitacao-auth";
import '../../../../../styles/leis-auth.scss'
import Moment from "moment";

const Licitacao = () => {
    let { id } = useParams();
    const [objeto, setObjeto] = useState("");
    const [unidadeGestora, setUnidadeGestora] = useState([]);
    const [processo, setProcesso] = useState("");
    const [licitacao, setLicitacao] = useState("");
    const [ano, setAno] = useState("");
    const [valor, setValor] = useState("");
    const [leiBeneficio, setLeiBeneficio] = useState("");
    const [orgao, setOrgao] = useState([]);
    const [modalidade, setModalidade] = useState("");
    const [situacao, setSituacao] = useState("");
    const [observacao, setObservacao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [dataLic, setDataLic] = useState("");
    const [hora, setHora] = useState("");
    const [sit, setSit] = useState("")

    async function fetchLic(id) {
        const response = await LicService.licEdit(id);
        Moment.locale();
        defineSituacao(response.data["situacao"]);
        setObjeto(response.data["objeto"]);
        if (response.data["unidadeGestora"]) {
            unidadeGestora.push(response.data["unidadeGestora"]);
        } else {
            unidadeGestora.push(response.data["unidadeG"]);
        }
        setProcesso(response.data["processo"]);
        setLicitacao(response.data["licitacao"]);
        setDataLic(Moment(response.data["dataLic"]).utc(false).format("DD/MM/YYYY"));
        setDataPub(Moment(response.data["dataPub"]).utc(false).format("DD/MM/YYYY"));
        setAno(response.data["ano"]);
        setValor(response.data["valor"]);
        setLeiBeneficio(response.data["leiBeneficio"]);
        if (response.data["orgao"]) {
            orgao.push(response.data["orgao"]);
        } else {
            orgao.push(response.data["orgaoS"])
        }

        setModalidade(response.data["modalidade"]);
        setSituacao(response.data["situacao"]);
        setObservacao(response.data["observacao"]);
        setHora(response.data["hora"]);
    }

    const defineSituacao = (situacao) => {

        switch (situacao) {
            case "Em Andamento":
                setSit("andamento")
                break;
            case "Publicada":
                setSit("avisos")
                break;
            case "Homologada":
            case "Cancelada":
                setSit("encerradas")
                break;
            default:
                setSit("todas")
                break;
        }
    }

    useEffect(() => {
        fetchLic(id)
    }, [id])

    return (
        <Fragment>
            <h5>Processo Nº{processo}/{ano}</h5>
            <Row xs={12}>
                <p><strong>Objeto: </strong>{objeto}</p>

                <strong>Unidades Gestoras:</strong>
                {unidadeGestora.map((fundo) =>
                    <p>{fundo}</p>
                )}
                <p><strong>Licitação: </strong>{licitacao}</p>
                <p><strong>Valor: </strong>R${valor}</p>
                <p><strong>Lei Benefício 123: </strong>{leiBeneficio}</p>
                <strong>Orgãos Solicitantes:</strong>
                {orgao.map((org) =>
                    <p>{org}</p>
                )}
                <p><strong>Modalidade: </strong>{modalidade}</p>
                <p><strong>Situação: </strong>{situacao}</p>
                {observacao ? <p><strong>Observação: </strong>{observacao}</p> : ''}
                <p><strong>Data da Licitacao: </strong>{dataLic}</p>
                <p><strong>Data de Publicação: </strong>{dataPub}</p>
                <p><strong>Horário do Certame: </strong>{hora}</p>

            </Row>
            <Link to={`/restrito/licitacao/editar/${id}`}>
                <Button type="button" variant='primary'>Editar</Button>
            </Link>
            <br /><br />
            <Link to={`/restrito/licitacao/listar/${sit}`}>
                <Button type='button' variant='danger'>Voltar</Button>
            </Link>
        </Fragment >)
}

export default Licitacao;